import BasicButton from "@components/button/BasicButton";
import BackHeader from "@components/header/BackHeader";
import styled from "@emotion/styled";
import BaseSwitch from "@pages/myPage/_component/BaseSwitch";
import useFilterStepStore from "@store/CategoryFilter/useFilterStepStore";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const Container = styled.div({
  backgroundColor: "white",
  padding: "2rem",
  position: "relative",
  height: "calc(100vh - 14rem)",
});

const SwitchWrapper = styled.div({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "2rem 0",
});

const Label = styled.span({
  fontSize: "1.6rem",
});

const ButtonWrapper = styled.div({
  position: "fixed",
  bottom: "-0.4rem",
  left: "50%",
  transform: "translateX(-50%)",
  width: "90%",
  maxWidth: "56rem",
  padding: "2rem",
  zIndex: 10,
});
const FreeShippingFee = () => {
  const { setStep } = useFilterStepStore();
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();
  const [tempFreeShipping, setTempFreeShipping] = useState(
    searchParams.get("is_free_shipping") === "1",
  );

  const handleToggle = (checked: boolean) => {
    setTempFreeShipping(checked);
  };

  const handleApply = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("is_free_shipping", tempFreeShipping ? "1" : "0");
    setSearchParams(newParams);
    setStep(0);
  };

  return (
    <>
      <BackHeader title="무료배송" onClick={() => setStep(1)} />
      <Container>
        <SwitchWrapper>
          <Label>{t("무료배송")}</Label>
          <BaseSwitch checked={tempFreeShipping} onChange={handleToggle} />
        </SwitchWrapper>

        <ButtonWrapper>
          <BasicButton
            title="적용"
            width="100%"
            height="5.2rem"
            onClick={handleApply}
          />
        </ButtonWrapper>
      </Container>
    </>
  );
};

export default FreeShippingFee;
